import { DatabaseRecord } from "@tellescope/types-models";
import { DatabaseRecordLabelOptions, labelForDatabaseRecord } from "./label-for-database-record";

export const transformDatabasePage = (
  items: { choices: DatabaseRecord[] },
  labelOptions: DatabaseRecordLabelOptions
): { value: string; label: string }[] =>
  items.choices
    .map((item) => ({
      label: labelForDatabaseRecord(labelOptions, item),
      value: item.id,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
